var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "mobile-nav-icon",
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9966 13.3138C24.8347 19.3045 19.6537 24.6799 13.6633 25.0037C12.4975 25.0685 11.3966 24.9714 10.328 24.7123C10.1337 24.6799 9.97181 24.7123 9.80991 24.8094L5.53561 27.5619C5.08228 27.8534 4.46704 27.4972 4.49942 26.979L4.6937 21.9922C4.6937 21.7979 4.62894 21.6036 4.49942 21.4741C2.26513 19.2397 0.937503 16.131 1.00227 12.7309C1.13179 6.57831 6.44228 1.20288 12.5947 1.00859C19.4918 0.749533 25.1585 6.38402 24.9966 13.3138Z",
    stroke: "#8B8B8D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3335 9.2015V11.9743C6.3335 12.5662 6.78804 13.0647 7.3941 13.0647C8.30319 13.0647 8.78804 14.1551 8.18198 14.8405C7.93956 15.0897 7.66683 15.339 7.30319 15.5571C6.81834 15.8375 6.66683 16.5229 6.93956 17.0213L7.15168 17.364C7.45471 17.8937 8.15168 18.0494 8.63653 17.7067C9.81835 16.8967 11.6668 15.1832 11.6668 12.6908V9.2015C11.6668 8.60956 11.2123 8.11108 10.6062 8.11108H7.3638C6.78804 8.14224 6.3335 8.60956 6.3335 9.2015Z",
    stroke: "#8B8B8D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3335 9.2015V11.9743C14.3335 12.5662 14.7855 13.0647 15.3881 13.0647C16.2921 13.0647 16.7742 14.1551 16.1715 14.8405C15.9305 15.0897 15.6593 15.339 15.2977 15.5571C14.8156 15.8375 14.6649 16.5229 14.9361 17.0213L15.1471 17.364C15.4484 17.8937 16.1414 18.0494 16.6235 17.7067C17.7987 16.8656 19.6668 15.152 19.6668 12.6908V9.2015C19.6668 8.60956 19.2149 8.11108 18.6122 8.11108H15.3881C14.8156 8.14224 14.3335 8.60956 14.3335 9.2015Z",
    stroke: "#8B8B8D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.c7d46e75aade7cc04dd6b633d3067080.svg";
export { ForwardRef as ReactComponent };